const getWidgetSettings = (): {
  color: string;
  company: string;
  bookingId: string | null;
  inline: boolean;
  language: string;
  locationId: string | null;
  mock: boolean;
  rwgToken: string | null;
  services: string[];
  source: string | null;
  type: 'booking' | 'giftcard' | 'workshop';
  widgetId: string | null;
} => {
  const searchParams = new URLSearchParams(window.location.search);

  let color = searchParams.get('color');
  if (!color || color === 'main') {
    color = '#FF6575';
  } else if (color === 'dark') {
    color = '#404043';
  }

  const companyId = searchParams.get('company');

  if (!companyId) {
    throw new Error('Company ID is required');
  }

  return {
    color,
    company: companyId,
    bookingId: searchParams.get('booking'),
    inline: searchParams.get('inline') === 'true',
    language: searchParams.get('language') || 'en',
    locationId: searchParams.get('location'),
    mock: searchParams.get('mock') === 'true',
    rwgToken: searchParams.get('rwgtoken'),
    source: searchParams.get('source'),
    services: searchParams.getAll('services[]')?.length
      ? searchParams.getAll('services[]')
      : searchParams.getAll('services%5B%5D'),
    type:
      searchParams.get('voucher') === 'true'
        ? 'giftcard'
        : searchParams.get('workshop') === 'true'
          ? 'workshop'
          : 'booking',
    widgetId:
      searchParams.get('widget_id') || searchParams.get('widget-id') || null
  };
};

export default Object.freeze(getWidgetSettings());
